import img50plus from "@/assets/50plus.png";
import img50plus2 from "@/assets/50plus-2.webp";
import img50plus3 from "@/assets/50plus-3.webp";
import img50plus4 from "@/assets/50plus-4.webp";
import img50plus5 from "@/assets/50plus-5.webp";
import imgMacfab75 from "@/assets/macfab75.webp";
import imgMacfab75_2 from "@/assets/macfab75-2.webp";
import imgMacfab75_3 from "@/assets/macfab75-3.webp";
import imgMacfab75_4 from "@/assets/macfab75-4.webp";
import imgMacfab75_5 from "@/assets/macfab75-5.webp";
import imgMacfab150 from "@/assets/macfab150.webp";
import imgMacfab150_2 from "@/assets/macfab150-2.webp";
import imgMacfab150_3 from "@/assets/macfab150-3.webp";
import imgMacfab150_4 from "@/assets/macfab150-4.webp";
import imgMacfab150_5 from "@/assets/macfab150-5.webp";
import img400plus from "@/assets/400plus.webp";
import img400plus2 from "@/assets/400plus-2.webp";
import img400plus3 from "@/assets/400plus-3.webp";
import img400plus4 from "@/assets/400plus-4.webp";
import img400plus5 from "@/assets/400plus-5.webp";
import imgVertikalni from "@/assets/vertikalni-lisy.webp";
import imgHorizontalni from "@/assets/horizontalni-lisy.webp";
import img600plus from "@/assets/600plus.webp";
import img600plus2 from "@/assets/600plus-2.webp";
import img600plus3 from "@/assets/600plus-3.webp";
import img600plus4 from "@/assets/600plus-4.webp";
import img600plus5 from "@/assets/600plus-5.webp";
import img600max from "@/assets/600max.webp";
import img600max2 from "@/assets/600max-2.webp";
import img600max3 from "@/assets/600max-3.webp";
import img600max4 from "@/assets/600max-4.webp";
import img600max5 from "@/assets/600max-5.webp";
import img800plus from "@/assets/800plus.webp";
import img800plus2 from "@/assets/800plus-2.webp";
import img800plus3 from "@/assets/800plus-3.webp";
import img800plus4 from "@/assets/800plus-4.webp";
import img800plus5 from "@/assets/800plus-5.webp";
import img800max from "@/assets/800max.webp";
import img800max2 from "@/assets/800max-2.webp";
import img800max3 from "@/assets/800max-3.webp";
import img800max4 from "@/assets/800max-4.webp";
import img800max5 from "@/assets/800max-5.webp";
import imgKompaktory from "@/assets/kompaktory.webp";
import imgBartontech300 from "@/assets/bartontech300.webp";
import imgEpsC200 from "@/assets/eps-c200.webp";
import imgEpsC200_2 from "@/assets/eps-c200-2.webp";
import imgEpsC200_3 from "@/assets/eps-c200-3.webp";
import imgEpsC200_4 from "@/assets/eps-c200-4.webp";
import imgEpsC50 from "@/assets/eps-c50.webp";
import imgEpsC50_2 from "@/assets/eps-c50-2.webp";
import imgEpsC50_3 from "@/assets/eps-c50-3.webp";
import imgEpsC50_4 from "@/assets/eps-c50-4.webp";

export type Product = {
  slug: string;
  name: string;
  category: "vertikalni" | "horizontalni" | "kompaktory";
  shortDescription: string;
  description: string;
  image: string;
  images?: string[];
  features: string[];
  specs?: { label: string; value: string }[];
  videoId?: string;
};

export const products: Product[] = [
  {
    slug: "50plus",
    name: "BartonTech 50Plus",
    category: "vertikalni",
    shortDescription: "Hydraulický paketovací lis na papír s malými rozměry a jednoduchým ovládáním.",
    description:
      "Hydraulický paketovací lis na papír BartonTech 50Plus se vyznačuje malými rozměry a jednoduchým ovládáním. Své uplatnění najde především v menších firmách, maloobchodě, obchodních domech, zdravotnických zařízeních, hotelech atd. Výborně se hodí pro lisování papíru, kartonu, plastových fólií a lahví a na separovaný odpad. Jeho předností jsou kompaktní rozměry a příznivá cena.",
    image: img50plus,
    images: [img50plus, img50plus2, img50plus3, img50plus4, img50plus5],
    features: [
      "Lisovací síla 4 tuny",
      "Kompaktní rozměry",
      "Napájení 240V",
      "Hmotnost balíku 50–60 kg",
      "Snadná obsluha",
    ],
    specs: [
      { label: "Rozměry (v × š × h)", value: "2180 × 810 × 745 mm" },
      { label: "Váha", value: "275 kg" },
      { label: "Plnící otvor (v × š)", value: "540 × 720 mm" },
      { label: "Rozměry balíku (v × š × h)", value: "600 × 715 × 500 mm" },
      { label: "Hmotnost balíku", value: "50–60 kg" },
      { label: "Pohon", value: "Hydraulický (elektromotor + hydraulické čerpadlo)" },
      { label: "Napájení", value: "240V" },
      { label: "Výkon motoru", value: "1,1 kW" },
      { label: "Lisovací síla", value: "4 t" },
      { label: "Vázání balíků", value: "Dvoubodové" },
      { label: "Doba cyklu", value: "Přibližně 45 vteřin" },
      { label: "Elektrické krytí", value: "IP55" },
      { label: "Lisovací poměr", value: "Až 90 %" },
    ],
    videoId: "ew_YgzI_5fM",
  },
  {
    slug: "bartontech-300",
    name: "BartonTech 300",
    category: "vertikalni",
    shortDescription: "Dvoukomorový vertikální lis pro efektivní třídění a lisování dvou druhů odpadu současně.",
    description:
      "Dvoukomorový vertikální lis BartonTech 300 umožňuje lisování dvou druhů odpadu současně. Díky dvěma nezávislým komorám je ideální pro provozy, kde je potřeba třídit a lisovat různé materiály – například papír a fólie. Šetří prostor i čas.",
    image: imgBartontech300,
    features: [
      "Dvě nezávislé komory",
      "Současné lisování dvou materiálů",
      "Úspora prostoru",
      "Robustní konstrukce",
      "Snadná obsluha",
    ],
  },
  {
    slug: "macfab-75",
    name: "MacFab 75 Multi",
    category: "vertikalni",
    shortDescription: "Vícekomorový vertikální lis s možností rozšíření o další komory. Ideální pro třídění více druhů odpadu v jednom stroji.",
    description:
      "Vícekomorový vertikální lis MacFab 75 Multi je skvělou volbou pro firmy, které chtějí lisovat více druhů materiálů v jednom stroji. Například jedna komora může sloužit pro karton, druhá pro plastovou fólii a třetí s vložkou může lisovat plechovky. Komory se plní shora, což usnadňuje obsluhu. Výborná volba pro širokou škálu provozů, zejména pro hotelnictví a gastronomii.",
    image: imgMacfab75,
    images: [imgMacfab75, imgMacfab75_2, imgMacfab75_3, imgMacfab75_4, imgMacfab75_5],
    features: [
      "Plnění materiálu shora",
      "Vhodný pro širokou škálu provozů",
      "Vozík pro vyjmutí balíku v ceně",
      "Dlouhý zdvih lisovacího válce",
      "Možnost rozšíření o další komory",
      "Galvanizovaný povrch jako volitelný doplněk",
    ],
    specs: [
      { label: "Výška", value: "2,30 m" },
      { label: "Šířka", value: "1,04 m" },
      { label: "Hloubka", value: "0,72 m" },
      { label: "Váha", value: "270 kg" },
      { label: "Transportní výška", value: "1,80 m" },
      { label: "Napájení", value: "220–230 V (jednofázové)" },
      { label: "Motor", value: "1,5 kW / 13 A" },
      { label: "Lisovací síla", value: "3,5 t" },
      { label: "Hlučnost", value: "72 dB" },
      { label: "Rozměry balíku (v × š × h)", value: "1000 × 700 × 500 mm" },
      { label: "Hmotnost balíku", value: "Do 75 kg" },
      { label: "Plnící otvor (v × š)", value: "698 × 700 mm" },
      { label: "Doba cyklu", value: "24 sekund" },
    ],
    videoId: "cT0rJiM9sU4",
  },
  {
    slug: "macfab-150",
    name: "MACFAB 150",
    category: "vertikalni",
    shortDescription: "Větší vertikální lis pro střední až větší objemy odpadu. Hmotnost balíku 150 kg.",
    description:
      "Další ze zástupců vertikální řady lisů. Větší rozměry umožňují zpracování většího objemu odpadu. Hmotnost balíku přibližně 150 kg. Vhodný pro firmy se středním objemem odpadového materiálu.",
    image: imgMacfab150,
    images: [imgMacfab150, imgMacfab150_2, imgMacfab150_3, imgMacfab150_4, imgMacfab150_5],
    features: [
      "Hmotnost balíku ~150 kg",
      "Větší objem komory",
      "Robustní konstrukce",
      "Spolehlivý provoz",
    ],
  },
  {
    slug: "400plus",
    name: "BartonTech 400Plus",
    category: "horizontalni",
    shortDescription: "Paketovací kanálový lis pro zpracování materiálů do 1 tuny za hodinu. Lisovací síla 50 tun.",
    description:
      "Paketovací kanálové lisy řady 400 jsou vhodné pro zpracování materiálů do 1 tuny za hodinu. Lisovací síla 50 tun. Ideální pro sběrné dvory a menší zpracovatele odpadu.",
    image: img400plus2,
    images: [img400plus2, img400plus, img400plus3, img400plus4, img400plus5],
    features: [
      "Lisovací síla 50 tun",
      "Zpracování do 1 t/h",
      "Automatický provoz",
      "Robustní konstrukce",
    ],
  },
  {
    slug: "600plus",
    name: "BartonTech 600Plus",
    category: "horizontalni",
    shortDescription: "Paketovací kanálový lis pro zpracování materiálů do 2 tun za hodinu. Lisovací síla 50 tun.",
    description:
      "Paketovací kanálové lisy řady 600 jsou vhodné pro zpracování materiálů do 2 tun za hodinu. Lisovací síla 50 tun. Určeno pro střední a větší zpracovatele odpadu.",
    image: img600plus,
    images: [img600plus, img600plus2, img600plus3, img600plus4, img600plus5],
    features: [
      "Lisovací síla 50 tun",
      "Zpracování do 1,5 t/h",
      "Vysoká produktivita",
      "Kontinuální lisování",
    ],
    specs: [
      { label: "Rozměry (v × š × h)", value: "2725 × 1435 × 5735 mm" },
      { label: "Váha stroje", value: "6000 kg" },
      { label: "Plnící otvor (v × š)", value: "1370 × 720 mm" },
      { label: "Rozměry balíku (v × š × h)", value: "1100 × 760 × 1200–1500 mm" },
      { label: "Hmotnost balíku", value: "200–500 kg" },
      { label: "Lisovací síla", value: "25–50 t" },
      { label: "Kapacita", value: "1,5 t/h" },
      { label: "Doba lisovacího cyklu", value: "15 kW / 60 s, 22 kW / 47 s" },
      { label: "Elektrický proud", value: "35 A (motor 15 kW)" },
      { label: "Napájení", value: "400 V" },
      { label: "Počet drátů", value: "5" },
      { label: "Směr vázání", value: "Horizontální" },
      { label: "Počet aktuátorů", value: "2" },
      { label: "Délka napájecího kabelu", value: "6 m" },
      { label: "Vnitřní elektrický okruh", value: "24 V DC" },
    ],
  },
  {
    slug: "600max",
    name: "BartonTech 600Max",
    category: "horizontalni",
    shortDescription: "Rozšíření modelu 600Plus s možností vysunutí jednotlivého balíku díky prodlouženému posunu.",
    description:
      "Rozšíření modelu 600Plus. Tento model navíc umožňuje vysunutí jednotlivého balíku díky prodlouženému posunu. Lze tedy vysunout každý jednotlivý balík samostatně. Ideální pro zpracovatele, kteří potřebují flexibilní manipulaci s balíky.",
    image: img600max,
    images: [img600max, img600max2, img600max3, img600max4, img600max5],
    features: [
      "Lisovací síla 50 tun",
      "Vysunutí jednotlivého balíku",
      "Prodloužený posun",
      "Flexibilní manipulace",
    ],
    specs: [
      { label: "Rozměry (v × š × h)", value: "2725 × 1435 × 7715 mm" },
      { label: "Váha stroje", value: "7000 kg" },
      { label: "Plnící otvor (v × š)", value: "1370 × 720 mm" },
      { label: "Rozměry balíku (v × š × h)", value: "1100 × 760 × 1510 mm" },
      { label: "Hmotnost balíku", value: "200–500 kg" },
      { label: "Lisovací síla", value: "50 t" },
      { label: "Kapacita", value: "1,5 t/h" },
      { label: "Doba lisovacího cyklu", value: "15 kW / 60 s, 22 kW / 47 s" },
      { label: "Elektrický proud", value: "35 A (motor 15 kW)" },
      { label: "Napájení", value: "400 V" },
      { label: "Počet drátů", value: "5" },
      { label: "Směr vázání", value: "Horizontální" },
      { label: "Počet aktuátorů", value: "1" },
      { label: "Délka napájecího kabelu", value: "6 m" },
      { label: "Vnitřní elektrický okruh", value: "24 V DC" },
    ],
  },
  {
    slug: "800plus",
    name: "BartonTech 800Plus",
    category: "horizontalni",
    shortDescription: "Nejvyšší řada paketovacích lisů. Lisovací síla 75 tun, zpracování do 2 t/h.",
    description:
      "Nejvyšší řada paketovacích lisů. Lisovací síla 75 tun. Zpracování odpadu do 2 tun za hodinu. Určeno pro velké zpracovatele a průmyslové provozy.",
    image: img800plus2,
    images: [img800plus2, img800plus, img800plus3, img800plus4, img800plus5],
    features: [
      "Lisovací síla 75 tun",
      "Zpracování do 2 t/h",
      "Průmyslový výkon",
      "Maximální odolnost",
    ],
    specs: [
      { label: "Rozměry (v × š × h)", value: "2805 × 1750 × 7050 mm" },
      { label: "Váha stroje", value: "7800 kg" },
      { label: "Plnící otvor (v × š)", value: "1900 × 970 mm" },
      { label: "Rozměry balíku", value: "1100 × 1020 × 1300–1500 mm" },
      { label: "Hmotnost balíku", value: "400–700 kg" },
      { label: "Lisovací síla", value: "75 t" },
      { label: "Kapacita", value: "2 t/h" },
      { label: "Doba lisovacího cyklu", value: "15 kW / 75 s, 22 kW / 60 s" },
      { label: "Elektrický proud", value: "35 A (motor 15 kW)" },
      { label: "Napájení", value: "400 V" },
      { label: "Počet drátů", value: "5" },
      { label: "Směr vázání", value: "Horizontální" },
      { label: "Počet aktuátorů", value: "2" },
      { label: "Délka napájecího kabelu", value: "6 m" },
      { label: "Vnitřní elektrický okruh", value: "24 V DC" },
    ],
  },
  {
    slug: "800max",
    name: "BartonTech 800Max",
    category: "horizontalni",
    shortDescription: "Rozšíření modelu 800Plus s možností vysunutí jednotlivého balíku díky prodlouženému posunu.",
    description:
      "Rozšíření modelu 800Plus. Tento model navíc umožňuje vysunutí jednotlivého balíku díky prodlouženému posunu. Lze tedy vysunout každý jednotlivý balík samostatně. Nejvyšší řada s lisovací silou 75 tun.",
    image: img800max,
    images: [img800max, img800max2, img800max3, img800max4, img800max5],
    features: [
      "Lisovací síla 75 tun",
      "Vysunutí jednotlivého balíku",
      "Prodloužený posun",
      "Maximální výkon",
    ],
    specs: [
      { label: "Rozměry (v × š × h)", value: "2805 × 1750 × 8350 mm" },
      { label: "Váha stroje", value: "7500 kg" },
      { label: "Plnící otvor (v × š)", value: "1900 × 970 mm" },
      { label: "Rozměry balíku", value: "1100 × 1020 × 1300–1500 mm" },
      { label: "Hmotnost balíku", value: "400–700 kg" },
      { label: "Lisovací síla", value: "75 t" },
      { label: "Kapacita", value: "2 t/h" },
      { label: "Doba lisovacího cyklu", value: "15 kW / 75 s" },
      { label: "Elektrický proud", value: "35 A (motor 15 kW)" },
      { label: "Napájení", value: "400 V" },
      { label: "Počet drátů", value: "5" },
      { label: "Směr vázání", value: "Horizontální" },
      { label: "Počet aktuátorů", value: "2" },
      { label: "Délka napájecího kabelu", value: "6 m" },
      { label: "Vnitřní elektrický okruh", value: "24 V DC" },
    ],
  },
  {
    slug: "eps-c50",
    name: "BartonTech EPS C50",
    category: "kompaktory",
    shortDescription: "Kompaktní kompaktor na polystyren s kompresním poměrem 40:1. Ideální pro menší provozy.",
    description:
      "Kompaktor na polystyren BartonTech EPS C50 zhušťuje polystyrenový odpad v poměru 40:1. Kompaktnější verze ideální pro menší provozy. Snižuje náklady a prostor zabíraný polystyrenovým odpadem. Nabízen ve verzi s elektronickým i manuálním ovládáním.",
    image: imgEpsC50,
    images: [imgEpsC50, imgEpsC50_2, imgEpsC50_3, imgEpsC50_4],
    features: [
      "Kompresní poměr 40:1",
      "Kompaktní rozměry",
      "Elektronické i manuální ovládání",
      "Jednoduchá obsluha",
      "Nízká spotřeba energie",
    ],
    specs: [
      { label: "Celkový příkon", value: "6,2 kW" },
      { label: "Rozměry (d × š × v)", value: "2000 × 600 × 1700 mm" },
      { label: "Váha", value: "690 kg" },
      { label: "Komprese", value: "40:1" },
      { label: "Hustota slisovaného EPS", value: "200–400 kg/m³" },
      { label: "Rozměry bloku EPS", value: "200 × 200 mm" },
    ],
  },
  {
    slug: "eps-c200",
    name: "BartonTech EPS C200",
    category: "kompaktory",
    shortDescription: "Kompaktor na polystyren s kompresním poměrem 50:1. Zpracování 50–200 kg/h.",
    description:
      "Kompaktor na polystyren BartonTech EPS C200 zhušťuje polystyrenový odpad v poměru 50:1. Lisování polystyrenu pomocí kompaktorů EPS snižuje náklady a prostor zabíraný polystyrenovým odpadem. Kompaktory EPS jsou velmi jednoduché na obsluhu, bezpečné a mohou být obsluhovány jednou osobou. Lisováním použitého polystyrenu a jeho opětovným využitím navíc chráníme životní prostředí.",
    image: imgEpsC200,
    images: [imgEpsC200, imgEpsC200_2, imgEpsC200_3, imgEpsC200_4],
    features: [
      "Kompresní poměr 50:1",
      "Zpracování 50–200 kg/h",
      "Jednoduchá obsluha jednou osobou",
      "Bezpečný provoz",
      "Ekologické řešení recyklace",
    ],
    specs: [
      { label: "Celkový příkon", value: "19,55 kW" },
      { label: "Rozměry (d × š × v)", value: "5425 × 750 × 2100 mm" },
      { label: "Váha", value: "2300 kg" },
      { label: "Plnící koš", value: "1000 × 645 × 1710 mm" },
      { label: "Rozměry bloku EPS", value: "380 × 380 mm" },
      { label: "Kapacita", value: "50–200 kg/h (dle hustoty suroviny)" },
      { label: "Komprese", value: "40:1" },
      { label: "Hustota slisovaného EPS", value: "200–400 kg/m³" },
    ],
    videoId: "goknS9LiIp4",
  },
];

export const getProductsByCategory = (category: Product["category"]) =>
  products.filter((p) => p.category === category);

export const getProductBySlug = (slug: string) =>
  products.find((p) => p.slug === slug);
